export default __webpack_public_path__ + "static/media/menu-bubble.98048267.svg";